import React, { useState, useEffect } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';
import { HHIEButton } from '../../utility/HHIEButton';

export function ServicesAndSolutionsAlert(props) {
    const [account, setAccount] = useState(props.account);
    const [serviceDiscussionInitiated, setServiceDiscussionInitiated] = useState(false);
    const [user, setUser] = useState(props.user);
    const [loading, setLoading] = useState(true);
    const [showAlert, setShowAlert] = useState(true);

    useEffect(() => {
        if (props.account && props.user) {
            setAccount(props.account);
            setUser(props.user);
            setLoading(false);
            CheckServiceDiscussionStarted();
        }
    }, [props]);


    const currentServices = () => {
        var services = "";

        if (account.registrationType && account.registrationType !== "") {
            services = account.registrationType;
        }
        else {
            if (account.chr) services += "CHR;";
            if (account.dsm) services += "DSM;";
            if (account.referrals) services += "Referrals;";
            if (account.notify) services += "Notify;";
            if (services.length > 0) {
                services = services.slice(0, -1);
            }
        }
        return services.replace(/;/g, "; ");
    }

    const remainingChrProviders = () => {
        return (parseInt(account.chrProviderLimit) - account.chrProviderCount);
    }

    const remainingChrStaff = () => {
        return (parseInt(account.chrStaffLimit) - account.chrStaffCount);
    }

    const remainingNotifyProviders = () => {
        return (parseInt(account.notifyProviderLimit) - account.notifyProvidersCount);
    }

    const remainingNotifyStaff = () => {
        return (parseInt(account.notifyStaffLimit) - account.notifyStaffCount);
    }

    const ChrAllowed = () => {
        var result;
        if (!account.chrIsLimited || (remainingChrProviders() > 0 && (!props.member || (props.member && props.provider)))|| (remainingChrStaff() > 0 && !props.provider)) {
            result = true;
        }
        else {
            result = false;
        }
        return result;
    }

    const NotifyAllowed = () => {
        var result;
        if (!account.notifyIsLimited || remainingNotifyProviders() > 0 || remainingNotifyStaff() > 0) {
            result = true;
        }
        else {
            result = false;
        }
        return result;
    }

    const CheckServiceDiscussionStarted = () => {
        fetch('/api/Registration/check-services-discussion-requested/' + account.id)
            .then((response) => {
                response.json()
                    .then((serviceDiscussionRequested) => {
                        if (serviceDiscussionRequested.errors !== null && serviceDiscussionRequested.errors !== "") alert(serviceDiscussionRequested.errors)
                        setServiceDiscussionInitiated(serviceDiscussionRequested.message)
                    })
                    .catch((serviceDiscussionError) => {
                        console.log("service Discussion json error: " + serviceDiscussionError)
                    })
            })
            .catch((serviceDiscussionResponseError) => {
                console.log("serviceDiscussionResponse Error: " + serviceDiscussionResponseError)
            })
    }

    const RequestServicesDiscussion = () => {
        const formData = new FormData();
        formData.append("userId", user.sfid)
        formData.append("account", account.id)

        const requestOptions = {
            method: "POST",
            body: formData
        }
        fetch('/api/Registration/RequestServicesDiscussion', requestOptions)
            .then((response) => {
                response.json()
                    .then((text) => {
                        if (text.errors !== null && text.errors !== "") alert(text.errors)
                        if (text.message.includes("Success")) {
                            setShowAlert(false);
                        }
                        alert(text.message);
                    })
                    .catch((error) => {
                        console.log("requestDiscussion Text Error: " + error);
                    })
            })
            .catch((error) => {
                console.log("requestDiscussion Response Error: " + error);
            });
    }



    return (
        <>
            {!loading &&
                    <Row>
                        <Col sm={2}></Col>
                        <Col className="d-flex justify-content-center">
                            <Alert
                                variant="primary"
                                style={{ borderRadius: '10px' }}
                                className="justify-content-center"
                                onClose={() => { setShowAlert(false) }}
                                show={!serviceDiscussionInitiated
                                    && showAlert
                                    && (
                                        (!ChrAllowed() && currentServices().includes("CHR"))
                                        ||
                                        (!NotifyAllowed() && currentServices().includes("Notify"))
                                    )
                                }
                                dismissible
                            >
                                <Row>
                                    <Col className="d-flex justify-content-center">
                                    Your account is unable to add the following service(s) to any more {!props.provider?<>members</>:<>providers</>}: {!ChrAllowed() && <>CHR</>} {!NotifyAllowed() && <>Notify</>}
                                    </Col>
                                </Row>
                                <hr />
                                <Row>
                                    <Col className="d-flex justify-content-center">
                                    <HHIEButton
                                        variant="primary"
                                        className="justify-content-center"
                                        size="sm"
                                        onClick={() => {
                                            RequestServicesDiscussion();
                                            CheckServiceDiscussionStarted();
                                        }}
                                        disabled={!user.isPOCUser}
                                        title={user.isPOCUser ? "Request discussion about adding access" : "This request is only for POCs"}
                                        />
                                    </Col>
                                </Row>
                            </Alert>
                            {serviceDiscussionInitiated &&
                                <Alert
                                    variant="primary"
                                    style={{ borderRadius: '10px' }}
                                    className="justify-content-center"
                                >
                                    Your organization has requested discussion with the HHIE regarding the current service & solutions limits on your organization.
                                </Alert>}
                        </Col>
                        <Col sm={2}></Col>
                    </Row>
            }

        </>
    );
}
